<template>
  <div :class="classes">
    <slot />

    <div class="buttons" v-if="firstButtonContent || secondButtonContent">
      <LinkButton
        v-if="firstButtonContent"
        button-type="filled"
        state="default"
        :target="firstButtonInNewWindow ? '_blank' : '_self'"
        theme="light"
        :url="firstButtonUrl"
        :fileName="firstButtonFileName"
        mobile-full-width
      >
        {{ firstButtonContent }}
      </LinkButton>

      <LinkButton
        v-if="secondButtonContent"
        button-type="outlined"
        state="default"
        :target="secondButtonInNewWindow ? '_blank' : '_self'"
        theme="light"
        :url="secondButtonUrl"
        :fileName="secondButtonFileName"
        mobile-full-width
      >
        {{ secondButtonContent }}
      </LinkButton>
    </div>
  </div>
</template>

<script lang="ts" setup>
import './TextBlock.scss';
import { computed } from 'vue';
import LinkButton from 'ewi-ui/components/1-atoms/LinkButton';

export interface TextBlockProps {
  textContainerWidth?: string;
  textContainerPosition?: string;
  textAlignment?: string;
  firstButtonContent?: string;
  firstButtonFileName?: string;
  firstButtonInNewWindow?: boolean;
  secondButtonContent?: string;
  secondButtonFileName?: string;
  secondButtonInNewWindow?: boolean;
  firstButtonUrl?: string;
  secondButtonUrl?: string;
}

const props = withDefaults(defineProps<TextBlockProps>(), {
  textContainerWidth: 'narrow',
  textContainerPosition: 'left',
  textAlignment: 'left',
  firstButtonContent: '',
  firstButtonFileName: '',
  firstButtonInNewWindow: false,
  secondButtonContent: '',
  secondButtonFileName: '',
  secondButtonInNewWindow: false,
  firstButtonUrl: '#',
  secondButtonUrl: '#',
});

const classes = computed(() => ({
  'm-text-block': true,
  [`text-container-width-${props.textContainerWidth}`]:
    props.textContainerWidth !== '',
  [`text-container-position-${props.textContainerPosition}`]:
    props.textContainerPosition !== '',
  [`text-align-${props.textAlignment}`]: props.textAlignment !== '',
}));
</script>
